import { DataItemType, FormControlType } from "../../../../form/schema";
import schema from "./schema";
import conduct from "./conduct";
import design from "./components/design.vue";
import pc from "../../../../form/src/common/components/form-staff-selector/pc/index.vue";
import mobile from "../../../../form/src/common/components/form-staff-selector/mobile/index.vue";
export const info = {
    title: "人员单选",
    title_i18n: "{\"zh\": \"人员单选\", \"en\": \"StaffSelector\"}",
    type: "staffSelector",
    icon: "h-icon-all-add-user-o",
    dataItemType: DataItemType.StaffSingle,
    formControllerType: FormControlType.StaffSelector,
    group: "基础控件",
};
export default {
    info,
    schema,
    conduct,
    components: {
        design,
        pc,
        mobile
    },
};
